export const availabilityApiQueryKeys = {
  all: () => ['availability'] as const,
  /**
   * Identyfikatory posortowane, bo kluczem jest **zbiór** pytanych pozycji —
   * ta sama lista w innej kolejności to nadal to samo pytanie.
   */
  forRefs: (tourId: string, refIds: string[]) =>
    ['availability', tourId, [...refIds].sort().join(',')] as const,
};
